<template>
    <div class="flex">
        <div class="mr-2 hidden text-gray-500 dark:text-txt-body sm:block">
            <CIcon :name="item.icon" size="large" />
        </div>
        <div class="sm:pb-1 sm:pt-1.5">
            <div class="text-smaller leading-5 text-gray-800 dark:text-txt-headings">
                {{ item.title }}

                <CTooltip v-if="item.subTitleTooltip">
                    {{ item.subTitleTooltip }}
                </CTooltip>
            </div>
            <div v-if="item.subTitle" class="pt-0.5 text-lg leading-5 text-black dark:text-txt-headings">
                <TextClap v-if="item.maxLength" as="strong" :limit-characters="item.maxLength" toggle-clap>
                    {{ item.subTitle }}
                </TextClap>

                <strong v-else>
                    {{ item.subTitle }}
                </strong>
            </div>

            <div v-if="item.secondaryRows?.length" class="mt-2 space-y-1">
                <div
                    v-for="secondaryRow in item.secondaryRows"
                    :key="`${secondaryRow.icon || 'text'}-${secondaryRow.text}`"
                    class="pt-0.5 text-lg leading-5 text-black dark:text-txt-headings"
                >
                    <strong>{{ secondaryRow.text }}</strong>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

import TextClap from '@/components/common/TextClap.vue'

export type ResourcesActionItemType = {
    icon: string
    title: string | number | null
    subTitle?: string
    subTitleTooltip?: string
    maxLength?: number
    secondaryRows?: {
        icon?: string
        text: string
    }[]
}

defineProps({
    item: {
        type: Object as PropType<ResourcesActionItemType>,
        required: true
    }
})
</script>
